"use strict";
exports.__esModule = true;
exports.changeOpenedStateOfTreeNode = exports.changeOpenedStateForAll = exports.generateTableIfContentsTree = exports.findLevelInTree = exports.getArrayOfItems = void 0;
var tslib_1 = require("tslib");
var utilities_1 = require("../../../utilities/utilities");
var constants_1 = tslib_1.__importDefault(require("./constants"));
var cleanTitle = function (title) {
    var result = title;
    if (title.length > constants_1["default"].TITLE_MAX_LENGTH) {
        result = title.slice(0, constants_1["default"].TITLE_MAX_LENGTH) + '...';
    }
    return result.replace('&nbsp;', ' ').replace(/\s\s+/g, ' ');
};
/**
 * Vyparsuje element paragrafu zakona a vrati node stromu pre generovanie obsahu.
 *
 * @param parentElement
 * @returns
 */
var getTreeNodeFromParagraphElement = function (parentElement, initialyExpanded) {
    var _a;
    if (initialyExpanded === void 0) { initialyExpanded = true; }
    // element musi mat povinne `data-` atributy (typ a level)
    if (parentElement.getAttribute('data-type') !== 'actsection') {
        return null;
    }
    var level = parentElement.getAttribute('data-level');
    if (!level) {
        return null;
    }
    var result = {
        id: '',
        title: '',
        href: '',
        level: Number(level),
        children: [],
        opened: initialyExpanded
    };
    // prejdeme vsetky sub-elementy a vyskladame obsah pre strom
    var elements = parentElement.getElementsByTagName('*');
    for (var i = 0; i < elements.length; i++) {
        var element = elements.item(i);
        var tagName = element ? element.tagName.toLocaleLowerCase() : '';
        // z prveho <a> vezmeme `id` a text markera
        if (tagName === 'a' && (element === null || element === void 0 ? void 0 : element.hasAttribute('id')) && !result.href) {
            var id = element.getAttribute('id');
            result.href = id ? "#" + id : '';
            result.title += element.textContent + ' ';
            result.id = result.href;
            // z div-ov vyskladame obsah title
        }
        else if (tagName === 'div') {
            result.title += (_a = element === null || element === void 0 ? void 0 : element.textContent) !== null && _a !== void 0 ? _a : '';
        }
    }
    if (!(result.title && result.href)) {
        return null;
    }
    result.title = cleanTitle(result.title);
    return result;
};
/**
 * Vrati pole elementov, z ktoreho sa bude generovat strom obsahu. Momentalne  obsah
 * generujeme z nadpisov a z widgetu "paragraf zakona".
 *
 * @param parentElement
 * @param initialyExpanded Kazdemu node nastavi, ci ma byt v ramci stromu inicialne expandnuty
 * @returns Array of tree items.
 */
exports.getArrayOfItems = function (parentElement, initialyExpanded) {
    if (initialyExpanded === void 0) { initialyExpanded = true; }
    var result = [];
    if (!parentElement) {
        return result;
    }
    var elements = parentElement.getElementsByTagName('*');
    for (var i = 0; i < elements.length; i++) {
        var element = elements.item(i);
        if (element) {
            var tagName = element.tagName.toLocaleLowerCase();
            if (tagName) {
                // nadpisy h1 - h6
                if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
                    var title = element.textContent || '';
                    var id = element.getAttribute('id');
                    result.push({
                        id: tagName + "-" + utilities_1.getRandomString(5),
                        title: cleanTitle(title),
                        href: "#" + id,
                        level: Number(tagName[1]),
                        opened: initialyExpanded,
                        children: []
                    });
                    // paragraf zakona (maju nizsiu uroven ako nadpisy - patria pod nadpis
                    // ako normalny text - preto ich level navysime o 6).
                }
                else if (tagName === 'div' &&
                    element.getAttribute('data-type') === 'actsection') {
                    var node = getTreeNodeFromParagraphElement(element);
                    if (node) {
                        node.level += 6;
                        result.push(node);
                    }
                }
            }
        }
    }
    return result;
};
/**
 * Najde node v strome, ktoreho priamym childom moze byt node s levelom
 * specifikovanym vo vstupnom parametri `level`.
 *
 * Hladame node, ktory nema child-ov, alebo jeho posledny child ma
 * `lastChild.level >= level`.
 *
 * Kedze pole elementov prechadzame sekvencne a z neho tvorime strom, staci
 * nam stale posledny node daneho levelu - preto `lastChild`.
 *
 * @param rootNode
 * @param level
 * @returns
 */
exports.findLevelInTree = function (rootNode, level) {
    if (level < rootNode.level) {
        return null;
    }
    var children = rootNode.children;
    var lastChild = children[children.length - 1];
    if (!lastChild || lastChild.level >= level) {
        return rootNode;
    }
    else {
        return exports.findLevelInTree(lastChild, level);
    }
};
/**
 * Vrati strom objektov pre zobrazenie obsahu textu.
 *
 * @param parentElement Parent element HTML obsahu, z ktoreho sabude generovat index
 * @param initialyExpanded Ci ma byt vygenerovany strom inicialne expandnuty alebo zatvoreny.
 * @returns
 */
exports.generateTableIfContentsTree = function (parentElement, initialyExpanded) {
    if (initialyExpanded === void 0) { initialyExpanded = true; }
    if (!parentElement) {
        return Promise.resolve([]);
    }
    return new Promise(function (resolve) {
        var flatHArray = exports.getArrayOfItems(parentElement, initialyExpanded);
        // z predpripraveneho flat array elementov spravime strom pre
        // generovanie obsahu
        var result = flatHArray.reduce(function (acc, item) {
            if (acc.length === 0) {
                acc.push(item);
            }
            else {
                var lastItemFromTree = acc[acc.length - 1];
                if (lastItemFromTree.level < item.level) {
                    // hladam node v strome, ktoreho novym childom bude aktualna item
                    // ak taky nenajdeme, item zaradime na najvyssiu uroven
                    var node = exports.findLevelInTree(lastItemFromTree, item.level);
                    if (node) {
                        node.children.push(item);
                    }
                    else {
                        acc.push(item);
                    }
                }
                else {
                    acc.push(item);
                }
            }
            return acc;
        }, []);
        resolve(result);
    });
};
/**
 * Expandne/collapsne cely strom (nerobi sa nova kopia stromu)
 *
 * @param tree
 * @param opened
 */
var changeOpenedStateOfAllNodes = function (tree, opened) {
    for (var _i = 0, tree_1 = tree; _i < tree_1.length; _i++) {
        var node = tree_1[_i];
        node.opened = opened;
        if (node.children.length) {
            changeOpenedStateOfAllNodes(node.children, opened);
        }
    }
};
/**
 * Expandne/collapsne cely strom a vrati novu referenciu (aby sa prerenderoval
 * komponent, v ktorom je strom pouzity)
 *
 * @param tree
 * @param opened
 * @returns
 */
exports.changeOpenedStateForAll = function (tree, opened) {
    changeOpenedStateOfAllNodes(tree, opened);
    return tslib_1.__spreadArrays(tree);
};
/**
 * Expandne/collapsne konkretny node stromu podla jeho `id` (in place - nerobi sa
 * nova kopia stromu).
 *
 * @param tree
 * @param id
 * @param opened
 * @returns
 */
var changeOpenedStateOfNode = function (tree, id, opened) {
    var found = false;
    for (var _i = 0, tree_2 = tree; _i < tree_2.length; _i++) {
        var node = tree_2[_i];
        if (node.id === id) {
            node.opened = opened;
            found = true;
        }
        if (node.children.length) {
            found = changeOpenedStateOfNode(node.children, id, opened);
        }
        if (found) {
            break;
        }
    }
    return found;
};
/**
 * Expandne/collapsne konkretny node stromu podla jeho `id` a vrati novu referenciu
 * (aby sa prerenderoval komponent, v ktorom je strom pouzity)
 *
 * @param tree
 * @param id
 * @param opened
 * @returns
 */
exports.changeOpenedStateOfTreeNode = function (tree, id, opened) {
    changeOpenedStateOfNode(tree, id, opened);
    return tslib_1.__spreadArrays(tree);
};
